// DOM Types
export var ITextBlockDataAttr;
(function (ITextBlockDataAttr) {
    ITextBlockDataAttr["TEXT"] = "data-text";
    ITextBlockDataAttr["INPUT"] = "data-input";
    ITextBlockDataAttr["PLACEHOLDER"] = "data-placeholder";
})(ITextBlockDataAttr || (ITextBlockDataAttr = {}));
